<template>
	<div class="logout">
		Logout
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'logout',
	mounted: function() {
		this.$store.dispatch('set_auth', null)
		this.$store.dispatch('set_order_id', null)
		this.$router.push({ name: 'login' })
	}
}
</script>
